import React, { Component } from 'react';
import { TouchableOpacity } from 'react-native';
import { Search } from '@mui/icons-material';

import styles from './styles';

export default class ButtonIcon extends Component {
    render() {
        const { query, onPress } = this.props;

        if (!query) return null;

        return (
            <TouchableOpacity style={styles.btn} onPress={onPress}>
                <Search
                    sx={{
                        fontSize: 24
                    }}
                    style={styles.iconSearch}
                />
            </TouchableOpacity>
        );
    }
}
